module.exports = __webpack_public_path__ + "assets/img/TLSC4-2.4b8daf18.jpg";